import { render, staticRenderFns } from "./SubscribesListView.vue?vue&type=template&id=5a50abe8&scoped=true&"
import script from "./SubscribesListView.vue?vue&type=script&lang=js&"
export * from "./SubscribesListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a50abe8",
  null
  
)

export default component.exports